import script from "./StudentLastNewsItem.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentLastNewsItem.vue?vue&type=script&setup=true&lang=js"

import "./StudentLastNewsItem.vue?vue&type=style&index=0&id=71edd9ac&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71edd9ac"]])

export default __exports__